const elChevrons = document.querySelectorAll('.chevron-trigger');

// console.log(elChevrons);

elChevrons.forEach( elChevron => {

    elChevron.addEventListener('click', function(e) {
        // console.log('working one', e.target)
        const elDropDown = e.target.closest('.chevron-dropdown')
        // console.log('working two', elDropDown)
        const isDropDownOpen = elDropDown.classList.contains('chevron--opened');

        if (isDropDownOpen) {
            elDropDown.classList.remove('chevron--opened');
            return;
        }

        //Remove open class
        document.querySelectorAll('.chevron-dropdown').forEach(el => {
        el.classList.remove('chevron--opened');
        })
        elDropDown.classList.add('chevron--opened');

        scrollToChevron(elDropDown);
    })
});


// Anchor to section

const scrollToChevron = (elDropDown) => {
    const elSection = elDropDown;
	const elStickyBanner = document.querySelector('.header');
	const yOffset = elStickyBanner.getBoundingClientRect().height;
	const position = elSection.getBoundingClientRect().top + window.pageYOffset - yOffset;

	// Scroll to section
	window.scrollTo({
		top: position,
		behavior: 'smooth'
	});
}